'use client';

import { ArrowUp } from 'lucide-react';
import type { NodeProps } from '../types';

export type BackToTopLinkProps = NodeProps<{
  behavior: 'auto' | 'smooth';
}> & { nested?: boolean };

export function BackToTopLink({ props }: BackToTopLinkProps) {
  return (
    <a
      className="flex w-fit items-center gap-1 text-secondary-foreground no-underline hover:underline"
      href="#"
      onClick={event => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: props.behavior });
      }}
    >
      <ArrowUp size={24} />
      Back to top
    </a>
  );
}
